import Axios from "axios"


export async function get_field_list(props) {
    const event_id = props['event_id']
    const Set_fieldList = props['Set_fieldList']

    const result = await Axios
                    .post('/event/field', {
                        event_id: event_id
                    })
    const data = result['data']

    Set_fieldList(data)
}